module.exports = __webpack_public_path__ + "img/butterfly-story.4ebc966.svg";